import BaseContainer from "./BaseContainer";
import {UIEvent} from "../const/Event";
export default class Scroller extends BaseContainer{
    constructor(){
        super();

        this.maskGraphic = new PIXI.Graphics();
        super.addChild(this.maskGraphic);
        this.mask = this.maskGraphic;

        this._viewport = new BaseContainer();
        super.addChild(this._viewport);

        this.leftPad = this.rightPad = this.topPad = this.bottomPad = 0;
    }

    addChild(child){
        this._viewport.addChild(child);
    }

    removeChild(child){
        this._viewport.removeChild(child);
    }

    scrollerToPercentH(percent){
        const x = (this._viewport.width - this.width) * percent;
        this.scrollH = x;
    }

    scrollerToPercentV(percent){
        const y = (this._viewport.height - this.height) * percent;
        this.scrollV = y;
    }

    get viewport(){
        return this._viewport;
    }

    get scrollH(){
        return -this._viewport.x;
    }
    set scrollH(val){
        this.viewport.x = Math.max(Math.min(-val, 0), -this.maxScrollH);
        this.emit(UIEvent.SCROLL_H);
    }

    get scrollV(){
        return - this.viewport.y;
    }

    set scrollV(val){
        this.viewport.y = Math.max(Math.min(-val, 0), -this.maxScrollV);
        this.emit(UIEvent.SCROLL_V);
    }

    get maxScrollH(){
        return Math.max(this.viewport.width - this.width, 0);
    }

    get maxScrollV(){
        return Math.max(this.viewport.height - this.height, 0);
    }

    /**
     * @param {Array | Number} paddings
     */
    set paddings(paddings){
        if((typeof paddings) == "number"){
            this.leftPad = this.rightPad = this.topPad = this.bottomPad = paddings;
        } else {
            [this.topPad, this.rightPad, this.bottomPad, this.leftPad] = paddings;
        }
        this.dirty();
    }

    _onSizeChanged(){
        super._onSizeChanged();
        this.dirty();
    }

    redraw(){
        this.maskGraphic.clear();
        this.maskGraphic.beginFill(0x0);
        this.maskGraphic.drawRect(-this.leftPad, -this.topPad, this.width + this.leftPad + this.rightPad, this.height + this.bottomPad + this.topPad);
        this.maskGraphic.endFill();
    }
}


// WEBPACK FOOTER //
// ./src/common/scripts/pixi/component/Scroller.js